/* ============================================================
   CUSTOM.JS – r-ough Theme Custom JavaScript
   Erstellt: 2026-02-24  |  Aktualisiert: 2026-02-24
   NICHT von Shopify-Theme-Updates überschrieben.
   ============================================================ */

(function () {
  'use strict';

  /* ============================================================
     HILFSFUNKTIONEN
     ============================================================ */

  function formatMoney(cents) {
    var amount = cents / 100;
    try {
      var currency =
        (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
      var locale = document.documentElement.lang || 'de-DE';
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2).replace('.', ',') + '\u00a0\u20ac';
    }
  }

  /* ============================================================
     1. CART NOTIFICATION
     ============================================================ */

  var notificationEl     = null;
  var notificationEnabled = true;   /* Default ON – wird von Section überschrieben */
  var autoClose          = true;
  var autoCloseSeconds   = 7;
  var hideTimer          = null;
  var processingAddToCart = false;  /* Verhindert Race Conditions */
  var preAddCartState = null;       /* Speichert Cart-State vor Add */
  var notificationShownTimestamp = 0; /* Timestamp der letzten Notification */

  function readNotificationSettings() {
    notificationEl = document.getElementById('custom-cart-notification');
    if (!notificationEl) return;

    /* Sicherere Prüfung: enabled AUSSER wenn explizit "false" gesetzt */
    var rawEnabled = notificationEl.dataset.enabled;
    notificationEnabled = (rawEnabled === undefined || rawEnabled === '' || rawEnabled === 'true');

    var rawAutoClose = notificationEl.dataset.autoClose;
    autoClose = (rawAutoClose === undefined || rawAutoClose === '' || rawAutoClose === 'true');

    autoCloseSeconds = parseInt(notificationEl.dataset.autoCloseSeconds, 10) || 7;
  }

  /* Erstellt eine Produkt-Zeile als DOM-Element (für renderItems und appendItems). */
  function createItemRow(item) {
    var src  = item.image || (item.featured_image && item.featured_image.url) || '';
    if (src && src.indexOf('//') === 0) src = 'https:' + src;

    var row = document.createElement('div');
    row.className = 'custom-cart-notification__product';
    row.dataset.variantId = item.variant_id || item.id || '';

    /* Bild */
    var imgWrap = document.createElement('div');
    imgWrap.className = 'custom-cart-notification__image-wrap';
    if (src) {
      var img = document.createElement('img');
      img.src = src;
      img.alt = item.product_title || item.title || '';
      img.className = 'custom-cart-notification__image';
      imgWrap.appendChild(img);
    }
    row.appendChild(imgWrap);

    /* Details */
    var details = document.createElement('div');
    details.className = 'custom-cart-notification__details';

    var titleEl = document.createElement('p');
    titleEl.className = 'custom-cart-notification__title';
    titleEl.textContent = item.product_title || item.title || '';
    details.appendChild(titleEl);

    var vt = item.variant_title;
    if (vt && vt !== 'Default Title') {
      var variantEl = document.createElement('p');
      variantEl.className = 'custom-cart-notification__variant';
      variantEl.textContent = vt;
      details.appendChild(variantEl);
    }

    var priceLine = document.createElement('p');
    priceLine.className = 'custom-cart-notification__price-line';

    var cp = item.original_price || item.compare_at_price;
    var fp = item.final_price || item.price || 0;
    if (cp && cp > fp) {
      var compareEl = document.createElement('span');
      compareEl.className = 'custom-cart-notification__compare-price';
      compareEl.textContent = formatMoney(cp);
      priceLine.appendChild(compareEl);
    }

    var priceEl = document.createElement('span');
    priceEl.className = 'custom-cart-notification__price';
    priceEl.textContent = formatMoney(fp);
    priceLine.appendChild(priceEl);

    details.appendChild(priceLine);
    row.appendChild(details);
    return row;
  }

  /* Leert den Container und rendert alle Items neu (erster Aufruf). */
  function renderItems(items) {
    var container = document.getElementById('ccn-items');
    if (!container) return;
    container.innerHTML = '';
    for (var i = 0; i < items.length; i++) {
      container.appendChild(createItemRow(items[i]));
    }
  }

  /* Hängt weitere Items an den sichtbaren Container an (Bundle/Nachzügler). */
  function appendItems(items) {
    var container = document.getElementById('ccn-items');
    if (!container) return;
    for (var i = 0; i < items.length; i++) {
      container.appendChild(createItemRow(items[i]));
    }
  }

  /* Aktualisiert ein bereits angezeigtes Item ODER fügt es hinzu, wenn es neu ist */
  function updateOrAppendItems(items) {
    var container = document.getElementById('ccn-items');
    if (!container) return;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var variantId = item.variant_id || item.id;

      /* Suche nach bereits vorhandenem Item mit gleicher variant_id */
      var existingRow = null;
      var rows = container.querySelectorAll('.custom-cart-notification__product');
      for (var j = 0; j < rows.length; j++) {
        var row = rows[j];
        if (row.dataset.variantId === String(variantId)) {
          existingRow = row;
          break;
        }
      }

      if (existingRow) {
        /* Item existiert bereits → Ersetze es (aktualisiert Preis nach Rabatt-Berechnung) */
        var newRow = createItemRow(item);
        existingRow.replaceWith(newRow);
      } else {
        /* Neues Item → Füge hinzu */
        container.appendChild(createItemRow(item));
      }
    }
  }

  function showCartNotification(items, source) {
    if (!notificationEl || !notificationEnabled) return;
    if (!Array.isArray(items)) items = [items];

    /* Markiere, dass Notification angezeigt wurde (für Debounce) */
    notificationShownTimestamp = Date.now();

    if (notificationEl.classList.contains('is-active')) {
      /* Notification bereits sichtbar → Items aktualisieren ODER ergänzen */
      updateOrAppendItems(items);
    } else {
      renderItems(items);
      notificationEl.classList.add('is-active');
    }

    /* Auto-Close-Timer zurücksetzen (jedes Mal neu starten) */
    if (autoClose) {
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(hideCartNotification, autoCloseSeconds * 1000);
    }
  }

  function hideCartNotification() {
    if (!notificationEl) return;
    notificationEl.classList.remove('is-active');
    if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
  }

  /* ============================================================
     2. FETCH-INTERCEPT – zwei Datenpfade

     PFAD A – Shopify REST /cart/add.js
       Für FastBundle-Bundles und alle Apps die die REST-API nutzen.
       Response enthält direkt alle Item-Felder.

     PFAD B – Shopify Storefront GraphQL (Kaching Cart)
       Kaching Cart umgeht /cart/add.js vollständig und nutzt das
       cartLinesAdd-Mutation über /api/.../graphql.json.
       Wir lesen die hinzugefügten Varianten aus dem Request-Body
       (variables.linesToAdd) und matchen sie mit den Cart-Lines
       in der Response.
     ============================================================ */

  var _fetch = window.fetch;
  window.fetch = async function (resource, init) {
    var url = typeof resource === 'string'
      ? resource
      : (resource && resource.url ? resource.url : '');

    var response = await _fetch.apply(window, arguments);

    try {
      /* ── PFAD A: REST /cart/add.js ─────────────────────────────── */
      if (url && url.indexOf('cart/add') !== -1) {
        response.clone().json().then(function (data) {
          var items;
          if (data && data.items && data.items.length > 0) {
            items = data.items;
          } else if (data && data.variant_id) {
            items = [data];
          } else {
            items = [];
          }
          if (items.length > 0) showCartNotification(items);
        }).catch(function () {});
      }

      /* ── PFAD B: Kaching Cart GraphQL ──────────────────────────── */
      else if (url && url.indexOf('graphql.json') !== -1 && init && init.body) {
        var reqBody = null;
        try { reqBody = JSON.parse(typeof init.body === 'string' ? init.body : ''); }
        catch (e) {}

        /* Merchandise-IDs aus den Request-Variablen extrahieren.
           Kaching Cart nutzt "linesToAdd", Standard-GraphQL nutzt "lines" –
           wir scannen alle Variablen nach einem Array mit merchandiseId. */
        var addedIds = [];
        if (reqBody && reqBody.variables) {
          var vars = reqBody.variables;
          var varKeys = Object.keys(vars);
          for (var k = 0; k < varKeys.length; k++) {
            var v = vars[varKeys[k]];
            if (Array.isArray(v) && v.length > 0 && v[0] && v[0].merchandiseId) {
              addedIds = v.map(function (l) { return l.merchandiseId; });
              break;
            }
          }
        }

        /* Nur weiter wenn eine cart-add-Mutation erkennbar ist */
        var queryStr = (reqBody && typeof reqBody.query === 'string') ? reqBody.query : '';
        var looksLikeCartAdd = addedIds.length > 0
          || queryStr.indexOf('cartLinesAdd') !== -1
          || queryStr.indexOf('cartAdd') !== -1;

        if (looksLikeCartAdd) {
          response.clone().json().then(function (data) {
            /* Cart-Daten aus ANY Mutations-Key holen (cartLinesAdd, cartAdd, ...) */
            var cartData = null;
            if (data && data.data) {
              var dKeys = Object.keys(data.data);
              for (var ki = 0; ki < dKeys.length; ki++) {
                var mutResult = data.data[dKeys[ki]];
                if (mutResult && mutResult.cart && mutResult.cart.lines) {
                  cartData = mutResult.cart;
                  break;
                }
              }
            }
            if (!cartData) return;

            var edges = (cartData.lines && cartData.lines.edges) || [];

            /* Passende Edges filtern – NUR wenn IDs bekannt sind */
            if (addedIds.length === 0) return; // Keine IDs → nichts anzeigen (Fallback auf Pfad C)

            var matchedEdges = edges.filter(function (edge) {
              return addedIds.indexOf(
                edge.node && edge.node.merchandise && edge.node.merchandise.id
              ) !== -1;
            });
            if (matchedEdges.length === 0) return;

            var items = matchedEdges.map(function (edge) {
              var node  = edge.node  || {};
              var merch = node.merchandise || {};
              var priceAmt   = merch.price        ? parseFloat(merch.price.amount)         * 100 : 0;
              var compareAmt = merch.compareAtPrice ? parseFloat(merch.compareAtPrice.amount) * 100 : 0;
              var vtParts = (merch.selectedOptions || [])
                .map(function (o) { return o.value; })
                .filter(function (v) { return v && v !== 'Default Title'; });
              return {
                product_title:  merch.product && merch.product.title,
                variant_title:  vtParts.length ? vtParts.join(' / ') : null,
                final_price:    priceAmt,
                price:          priceAmt,
                original_price: compareAmt,
                image:          merch.image && (merch.image.transformedUrl || merch.image.url)
              };
            });

            if (items.length > 0) showCartNotification(items);
          }).catch(function () {});
        }
      }
    } catch (e) {}

    return response;
  };

  /* ============================================================
     3. FALLBACK: EVENT-BASIERTER DIFF-MECHANISMUS
     Fängt Fälle ab, in denen weder PFAD A noch PFAD B greift
     (z.B. Kaching Bundle "skipped" ohne ID-Matching).
     Vergleicht Cart VOR und NACH dem Add → zeigt nur neue Items.
     ============================================================ */

  /* Hilfsfunktion: Holt den aktuellen Cart-State */
  function getCartState() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        return cart && cart.items ? cart.items.map(function (item) {
          return {
            key: item.key,              // Eindeutiger Identifier (variant_id:properties)
            variant_id: item.variant_id,
            quantity: item.quantity
          };
        }) : [];
      })
      .catch(function () { return []; });
  }

  /* Hilfsfunktion: Findet neue/geänderte Items durch Diff */
  function findNewItems(oldState, newState) {
    var oldMap = {};
    for (var i = 0; i < oldState.length; i++) {
      oldMap[oldState[i].key] = oldState[i].quantity;
    }

    var addedKeys = [];
    for (var j = 0; j < newState.length; j++) {
      var newItem = newState[j];
      var oldQty = oldMap[newItem.key] || 0;
      if (newItem.quantity > oldQty) {
        addedKeys.push(newItem.key);
      }
    }

    return addedKeys;
  }

  /* Event-Listener für cart:update */
  document.addEventListener('cart:update', function (e) {
    if (!notificationEnabled) return;

    var detail = e.detail || {};
    var data = detail.data || {};

    /* Nur bei product-form-component (echter Add-to-Cart) */
    if (data.source !== 'product-form-component') return;
    if (data.didError === true) return;
    if (!data.itemCount || data.itemCount <= 0) return;

    /* KRITISCH: Nur als Fallback, wenn PFAD A/B nicht getriggert haben
       Prüfe ob eine Notification kürzlich angezeigt wurde */
    var timeSinceLastNotification = Date.now() - notificationShownTimestamp;
    if (timeSinceLastNotification < 300) {
      preAddCartState = null; // Reset, damit nachfolgende Events ignoriert werden
      return; // PFAD A/B hat bereits getriggert (< 300ms her)
    }

    /* Nur beim ERSTEN cart:update nach einem Add (preAddCartState gesetzt) */
    if (!preAddCartState) return;

    if (processingAddToCart) return; // Verhindere doppelte Verarbeitung
    processingAddToCart = true;

    /* Warte kurz, damit Cart aktualisiert ist */
    setTimeout(function () {
      getCartState().then(function (postAddState) {
        if (!preAddCartState) {
          /* Kein Vor-State → zeige die letzten N Items (Best Effort) */
          fetch('/cart.js')
            .then(function (res) { return res.json(); })
            .then(function (cart) {
              if (!cart || !cart.items || cart.items.length === 0) return;
              var itemCount = data.itemCount || 1;
              var recentItems = cart.items.slice(-itemCount);
              showCartNotification(recentItems);
              processingAddToCart = false;
            })
            .catch(function () { processingAddToCart = false; });
          return;
        }

        /* Diff: Finde neue Items */
        var newKeys = findNewItems(preAddCartState, postAddState);

        if (newKeys.length === 0) {
          processingAddToCart = false;
          return;
        }

        /* Hole vollständige Item-Daten */
        fetch('/cart.js')
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            if (!cart || !cart.items) {
              processingAddToCart = false;
              return;
            }

            var newItems = cart.items.filter(function (item) {
              return newKeys.indexOf(item.key) !== -1;
            });

            if (newItems.length > 0) {
              showCartNotification(newItems);
            }

            processingAddToCart = false;
            preAddCartState = null; // Reset
          })
          .catch(function () {
            processingAddToCart = false;
            preAddCartState = null;
          });
      });
    }, 100); // 100ms Verzögerung für Cart-Update
  });

  /* Vor jedem Submit: Cart-State speichern */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[type="submit"][name="add"]');
    if (!btn) return;

    /* Nur bei Add-to-Cart-Buttons */
    var form = btn.closest('form[action*="/cart/add"]');
    if (!form) return;

    /* Speichere Cart-State VOR dem Add */
    getCartState().then(function (state) {
      preAddCartState = state;
    });
  });

  /* ============================================================
     4. PREIS IN ADD-TO-CART BUTTON INJIZIEREN
     Nur wenn "show_price_in_button" im Buy-Buttons-Block aktiv.
     ============================================================ */

  function initButtonPrices() {
    document.querySelectorAll('.buy-buttons-block[data-show-price="true"]').forEach(function (block) {
      var section = block.closest('.shopify-section');
      if (!section) return;

      var btn = block.querySelector('button.add-to-cart-button');
      if (!btn) return;

      /* Section markieren → CSS versteckt product-price automatisch */
      section.classList.add('custom-price-in-button-active');

      /* Variant-Preisdaten aus dem eingebetteten JSON-Script lesen */
      var priceScriptEl = block.querySelector(
        'script[type="application/json"][id^="BuyButtons-VariantPrices-"]'
      );
      if (!priceScriptEl) return;

      var priceData;
      try {
        priceData = JSON.parse(priceScriptEl.textContent);
      } catch (e) {
        return;
      }

      function getCurrentVariant() {
        var params    = new URLSearchParams(window.location.search);
        var urlId     = params.get('variant');
        var formInput = block.querySelector('input[name="id"]');
        var formId    = formInput ? formInput.value : null;
        var id        = urlId || formId;
        if (id && priceData.variants) {
          return priceData.variants.find(function (v) { return String(v.id) === String(id); });
        }
        return priceData.variants && priceData.variants[0];
      }

      function updateBtnPrice(variant) {
        if (!variant) return;
        var wrapper = btn.querySelector('.custom-atc-price-wrapper');
        if (!wrapper) {
          wrapper = document.createElement('span');
          wrapper.className = 'custom-atc-price-wrapper';
          btn.appendChild(wrapper);
        }
        var html = '';
        if (variant.compare && variant.compare.length > 0) {
          html += '<span class="custom-atc-compare-price">' + variant.compare + '</span>';
        }
        html += '<span class="custom-atc-price">' + variant.price + '</span>';
        wrapper.innerHTML = html;
      }

      updateBtnPrice(getCurrentVariant());

      /* Varianten-Wechsel per URL-Polling erkennen */
      var lastSearch = window.location.search;
      setInterval(function () {
        if (window.location.search === lastSearch) return;
        lastSearch = window.location.search;
        updateBtnPrice(getCurrentVariant());
      }, 200);

      /* Fallback: Formular-Input beobachten */
      var formInput = block.querySelector('input[name="id"]');
      if (formInput) {
        new MutationObserver(function () {
          updateBtnPrice(getCurrentVariant());
        }).observe(formInput, { attributes: true, attributeFilter: ['value'] });
      }
    });
  }

  /* ============================================================
     5. INIT
     ============================================================ */

  function init() {
    readNotificationSettings();
    initButtonPrices();

    var closeBtn    = document.getElementById('custom-cart-notification-close');
    var continueBtn = document.getElementById('custom-cart-notification-continue');
    var cartBtn     = notificationEl && notificationEl.querySelector('.custom-cart-notification__cart-btn');
    if (closeBtn)    closeBtn.addEventListener('click', hideCartNotification);
    if (continueBtn) continueBtn.addEventListener('click', hideCartNotification);
    if (cartBtn)     cartBtn.addEventListener('click', function () {
      hideCartNotification();
      /* Horizon-Cart-Trigger-Button im Header simulieren – identischer Codepfad wie Klick auf das Warenkorb-Icon */
      var cartTrigger = document.querySelector('button[on\\:click="/open"][aria-haspopup="dialog"]');
      if (cartTrigger) {
        cartTrigger.click();
      } else {
        window.location.href = '/cart';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    readNotificationSettings();
    initButtonPrices();
  });

})();
